import { useEffect } from "react";

function prepareImage(image: HTMLImageElement) {
  if (image.dataset.lazyFadeReady === "true") return;
  image.dataset.lazyFadeReady = "true";

  const reveal = () => {
    if (image.naturalWidth > 0) image.dataset.loaded = "true";
  };

  if (image.complete) reveal();
  else image.addEventListener("load", reveal, { once: true });
}

export default function LazyImageFadeController() {
  useEffect(() => {
    const prepareAll = (root: ParentNode) => {
      root.querySelectorAll<HTMLImageElement>("img[data-lazy-fade]").forEach(prepareImage);
    };

    prepareAll(document);
    const observer = new MutationObserver(records => {
      records.forEach(record => {
        record.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches("img[data-lazy-fade]")) prepareImage(node as HTMLImageElement);
          prepareAll(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return null;
}
